(function () {
  var INTERVAL = 2000; // ms between image swaps — match the mockup

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function cardOf(carousel) {
    return carousel.closest('.card-wrapper');
  }

  function start(carousel) {
    var imgs = carousel.querySelectorAll('.rp-carousel__img');
    var dots = carousel.querySelectorAll('.rp-carousel__dot');
    if (imgs.length < 2) return;
    stop(carousel);            // guard against double-start
    var i = 0;
    carousel._rpTimer = setInterval(function () {
      imgs[i].classList.remove('is-active');
      if (dots[i]) dots[i].classList.remove('is-active');
      i = (i + 1) % imgs.length;              // loop
      imgs[i].classList.add('is-active');
      if (dots[i]) dots[i].classList.add('is-active');
    }, INTERVAL);
  }

  function stop(carousel) {
    if (carousel._rpTimer) { clearInterval(carousel._rpTimer); carousel._rpTimer = null; }
    // reset to first image
    carousel.querySelectorAll('.rp-carousel__img').forEach(function (el, idx) {
      el.classList.toggle('is-active', idx === 0);
    });
    carousel.querySelectorAll('.rp-carousel__dot').forEach(function (el, idx) {
      el.classList.toggle('is-active', idx === 0);
    });
  }

  // Delegated hover — survives AJAX-replaced grids
  document.addEventListener('mouseover', function (e) {
    var card = e.target.closest('.card-wrapper');
    if (!card) return;
    var carousel = card.querySelector('[data-rp-carousel]');
    if (carousel && !carousel._rpTimer && !reduce.matches) start(carousel);
  });
  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest('.card-wrapper');
    if (!card) return;
    // only stop when the pointer truly left the card
    if (card.contains(e.relatedTarget)) return;
    var carousel = card.querySelector('[data-rp-carousel]');
    if (carousel) stop(carousel);
  });

  // Keyboard focus parity (tab onto a card → cycle; blur → stop)
  document.addEventListener('focusin', function (e) {
    var card = e.target.closest('.card-wrapper');
    if (!card) return;
    var carousel = card.querySelector('[data-rp-carousel]');
    if (carousel && !carousel._rpTimer && !reduce.matches) start(carousel);
  });
  document.addEventListener('focusout', function (e) {
    var card = e.target.closest('.card-wrapper');
    if (!card || card.contains(e.relatedTarget)) return;
    var carousel = card.querySelector('[data-rp-carousel]');
    if (carousel) stop(carousel);
  });
})();
